// extracted by mini-css-extract-plugin
var _1 = "centered-icon__nDo78";
export { _1 as "centeredIcon" }
